import { render, staticRenderFns } from "./MenuFilter.vue?vue&type=template&id=7ae3bc56"
import script from "./MenuFilter.vue?vue&type=script&lang=js"
export * from "./MenuFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports